export const TOTAL_COMPENSATION_STATEMENT_QUERY_KEY = "totalCompensationStatement";
